<template>
  <UInputMenu v-model="selected" :search="searchAction" :loading="loading"
    placeholder="Search for area, street name, etc." option-attribute="name" by="id" size="lg" rounded
    :popper="{ arrow: true }" :ui="{ rounded: 'rounded-lg' }" leading-icon="i-heroicons-magnifying-glass"
    trailingIcon='false' @click="onClickHandler">
  </UInputMenu>
</template>


<script setup lang="ts">
import { UInputMenu } from '#components';
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';

const location = useLocation();

const geolocation = useGeoLocation();
const gps = computed(() => geolocation.selectedAddress?.gps);
const hasLocation = computed(() => !!(gps.value?.latitude && gps.value?.longitude));
const latitude = computed(() => gps.value?.latitude || '0');
const longitude = computed(() => gps.value?.longitude || '0');
const selectedAddress = computed(() => geolocation.formatSelectedAddress)

const checkout = useCheckout();
const loading = ref(false);
const selected = ref();
const emit = defineEmits(['success', 'error']);

async function searchAction(q: string) {
  if (q.length < 3) {
    return [];
  }
  try {
    loading.value = true;
    const response = await useAPIHandler("post", "/maps/location/search", {
      body: { text: q },
    });
    return response.data.map((item: string, index: number) => ({
      id: index,
      name: item,
    }));
  } catch (err) {
    location.value = "Address not found"
  } finally {
    loading.value = false;
  }
}



watch(selected, async (newValue) => {
  if (newValue) {
    GoogleAnalytics.locationEvent({
      [EventParameter.ACTION]: 'location_selected_from_search',
      [EventParameter.LATITUDE]: latitude.value,
      [EventParameter.LONGITUDE]: longitude.value,
      [EventParameter.ADDRESS]: selectedAddress.value || 'none',
      [EventParameter.REASON]: 'none',
      [EventParameter.LOCATION_AVAILABLE]: hasLocation.value ? "yes" : "no",
      [EventParameter.PROMPT_TYPE]: "none",
      [EventParameter.NEEDS_LOCATION_FETCH]: hasLocation.value ? "no" : "yes",
    });
    loading.value = true;
    const result = await geolocation.setLocationByAddress(newValue.name);
    checkout.delivery_address = null
    loading.value = false;
    if (!result?.success) {
      emit('error', result?.message);
      return;
    }
    emit('success');
  }
})

const onClickHandler = async () => {
  GoogleAnalytics.locationEvent({
    [EventParameter.ACTION]: 'location_search_initiated',
    [EventParameter.LATITUDE]: latitude.value,
    [EventParameter.LONGITUDE]: longitude.value,
    [EventParameter.ADDRESS]: selectedAddress.value || 'none',
    [EventParameter.REASON]: 'none',
    [EventParameter.LOCATION_AVAILABLE]: hasLocation.value ? "yes" : "no",
    [EventParameter.PROMPT_TYPE]: "none",
    [EventParameter.NEEDS_LOCATION_FETCH]: hasLocation.value ? "no" : "yes",
  })
};


</script>
